module.exports = __webpack_public_path__ + "img/banner-loreal.e0c874ae.png";